import React, { useCallback, useEffect, useState } from "react";

import { Box } from "@mui/material";

type Props = {
  onFileUpload: (file: File) => void;
  file?: File;
};

export const FileUpload = (props: Props) => {
  const { onFileUpload, file } = props;
  const [highlight, setHighlight] = useState(false);
  const [fileName, setFileName] = useState<string | null>(file?.name ?? null);

  useEffect(() => {
    if (file) {
      setFileName(file.name);
    }
  }, [file]);

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setHighlight(true);
  }, []);

  const handleDragLeave = useCallback(() => {
    setHighlight(false);
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setHighlight(false);

      const droppedFile = e.dataTransfer.files[0];
      if (droppedFile) {
        setFileName(droppedFile.name);
        onFileUpload(droppedFile);
      }
    },
    [onFileUpload],
  );

  const handleFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files?.[0];
      if (selectedFile) {
        setFileName(selectedFile.name);
        onFileUpload(selectedFile);
      }
    },
    [onFileUpload],
  );

  return (
    <Box
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => document.getElementById("fileInput")?.click()}
      p={2}
      py={4}
      border={"2px dashed #999"}
      borderRadius={2}
      bgcolor={highlight ? "#eef" : "#f9f9f9"}
    >
      <input
        id="fileInput"
        data-testid="file-input"
        style={{ display: "none" }}
        type="file"
        onChange={handleFileChange}
      />
      <p>
        {fileName
          ? `Selected: ${fileName}`
          : "Drag & drop a file here, or click to select"}
      </p>
    </Box>
  );
};
